module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



// WEBPACK FOOTER //
// ./~/readable-stream/lib/internal/streams/from-browser.js